//woker-builder.js
export default class WorkerBuilder extends Worker {
  constructor(worker) {
    const code = worker.toString();
    const blob = new Blob([`(${code})()`]);
    const workerObj = new Worker(URL.createObjectURL(blob));
    return workerObj
  }
}